import serviceParcelaCoordenada from '@/services/GsEncuesta/parcelaCoordenada'

export default {
  PARCELA_COORDENADA_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcelaCoordenada.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_FIND_BY_ID_PARCELA(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcelaCoordenada.findByIdParcela(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_COORDENADA_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcelaCoordenada.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_COORDENADA_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcelaCoordenada.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_COORDENADA_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcelaCoordenada.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
